<script setup>
import { ref, defineExpose } from 'vue'
import { useSignaturePad } from '@/composables/useSignaturePad'

const canvasRef = ref(null)
const { isEmpty, clear, toDataURL } = useSignaturePad(canvasRef)

defineExpose({ isEmpty, clear, toDataURL })
</script>

<template>
  <div class="space-y-3">
    <div class="w-full max-w-xl mx-auto aspect-[8/3] rounded-lg border-2 border-dashed border-outline-variant/40 bg-white overflow-hidden">
      <canvas ref="canvasRef" class="w-full h-full block touch-none" />
    </div>
    <p class="text-center text-xs text-outline">Signez ci-dessus</p>
  </div>
</template>
